import globalBannerStyles from '../GlobalBannerComponent/GlobalBannerStyles';
import constants from '../../constants';

const styles = {
    success: {
      bannerType: globalBannerStyles.success,
      message: 'Your phone number has been successfully verified and your account has been created! Please answer a few more questions to get into the portal.',
    },
    E100: {
      bannerType: globalBannerStyles.error,
      message: 'Welcome back! Looks like you\'ve already created an account with this information. Go ahead and log in.',
      linkText: 'Log in',
    },
    E100A: {
      bannerType: globalBannerStyles.error,
      message: 'The username is already associated with an AMsuite+ account.',
    },
    E200: {
      bannerType: globalBannerStyles.warning,
      message: 'We have identified your username as a Licensed agent. Please provide the additional information requested below.',
    },
    info: {
      bannerType: globalBannerStyles.info,
      message: 'The username that you provided is not set up as a licensed user in our system. If this needs to be updated, please use live chat or contact Producer Management at licensingandcontracts@amig.com. You may proceed as a non-licensed user.',
      linkText: 'Continue',
    },
    sso: {
      bannerType: globalBannerStyles.error,
      icon: require('../../common/assets/img/error-icon.png'),
      message: 'That username cannot be added while you\'re logged in through this managing group\'s system. Please log out and log in directly to AMsuite+ through agents.amig.com.',
    },
    E300: {
      bannerType: globalBannerStyles.error,
      icon: require('../../common/assets/img/error-icon.png'),
      message: 'The information does not match our records. Please check the information entered and try again. If you need further assistance, contact system support via chat or email at systemsupport@amig.com.',
    },
    E300A: {
      bannerType: globalBannerStyles.error,
      icon: require('../../common/assets/img/error-icon.png'),
      message: 'The information does not match our records. Please check the information entered and try again.',
    },
    E400: {
      bannerType: globalBannerStyles.error,
      message: 'The username entered is no longer active. Please contact producer management at (800) 759-9008 option 2 if you feel this is an error.',
    },
    E900: {
      bannerType: globalBannerStyles.error,
      message: constants.serviceUnavailableMsg + ' ' + constants.contactSystemSupportMsg,
    },
  };

  export default styles;